<template>
  <img
    width="20px"
    height="20px"
    src="@/assets/icon/filterInit.svg"
    alt="filterIcon">
</template>

<script>

export default {
  name: 'CoozzyFilterInitIcon'
}
</script>

<style lang="scss" scoped>
</style>
